export const COMPANY = {
  name: "GLG Technology",
  email: "info@glghn.com",
  phoneDisplay: "+504 9639-0722",
  phoneRaw: "50496390722",
  location: "Honduras",
  website: "www.glghn.com",
};

export const WHATSAPP_DEFAULT_MESSAGE =
  "Hola GLG Technology, me gustaría solicitar información sobre una solución tecnológica.";

export const waLink = (message = WHATSAPP_DEFAULT_MESSAGE, phone = COMPANY.phoneRaw) =>
  `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

export const scrollToId = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (typeof window !== "undefined" && window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const NAV_LINKS = [
  { label: "Inicio", href: "#inicio" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Servicios", href: "#servicios" },
  { label: "Tecnología", href: "#tecnologia" },
  { label: "Contacto", href: "#contacto" },
];

export const ASSETS = {
  logo: "/brand/glg-logo.png",
  heroBg:
    "https://images.pexels.com/photos/30692441/pexels-photo-30692441.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
};

// "Por qué elegir GLG" — static, verifiable positioning (no invented stats)
export const ADVANTAGES = [
  { n: "01", title: "Experiencia técnica", description: "Conocimiento especializado para diseñar soluciones adecuadas a cada proyecto." },
  { n: "02", title: "Soluciones personalizadas", description: "Cada proyecto se adapta a las necesidades reales del cliente." },
  { n: "03", title: "Integración tecnológica", description: "Conectamos distintos sistemas en una sola solución completa." },
  { n: "04", title: "Soporte posterior", description: "Acompañamiento y mantenimiento después de la instalación." },
  { n: "05", title: "Atención profesional", description: "Comunicación clara y respuesta ágil en cada etapa." },
];

// "Cómo trabajamos" — static process
export const PROCESS = [
  { n: "01", title: "Conocemos tu necesidad", description: "Escuchamos y entendemos tu proyecto y objetivos." },
  { n: "02", title: "Diseñamos la solución", description: "Planificamos la mejor arquitectura para tu caso." },
  { n: "03", title: "Instalamos y configuramos", description: "Implementación técnica ordenada y profesional." },
  { n: "04", title: "Probamos y entregamos", description: "Verificamos el correcto funcionamiento de todo." },
  { n: "05", title: "Seguimos contigo", description: "Soporte y mantenimiento continuo tras la entrega." },
];
